import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import MobileAppPopup from '../../components/MobileAppPopup'
import BlogFooter from '../../components/blog/Footer'
import { gotoSignUp } from '../../redux/actions/AuthActions'
import AIStudioHeroSection from './components/AIStudioHeroSection'
import CreativeControlSection from './components/CreativeControlSection'
import DesignAnywhereSection from './components/DesignAnywhereSection'
import MadeForEveryHomeSection from './components/MadeForEveryHomeSection'
import AIBeforeAfterSection from './components/AIBeforeAfterSection'
import MoreWaysSection from './components/MoreWaysSection'
import StartDesigningSection from './components/StartDesigningSection'
import FAQSection from './components/FAQSection'

const PageWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  background: white;
`

const AIStudio = () => {
  const dispatch = useDispatch()

  const openSignUp = () => {
    dispatch(gotoSignUp())
  }

  return (
    <PageWrapper>
      <AIStudioHeroSection onActionClick={openSignUp} />
      <AIBeforeAfterSection onActionClick={openSignUp} />
      <CreativeControlSection onActionClick={openSignUp} />
      <MoreWaysSection onActionClick={openSignUp} />
      <MadeForEveryHomeSection />
      <DesignAnywhereSection onActionClick={openSignUp} />
      <FAQSection />
      <StartDesigningSection onActionClick={openSignUp} />
      <BlogFooter />
      <MobileAppPopup />
    </PageWrapper>
  )
}

export default AIStudio
